var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgC = function SvgC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.403 19.393C47.15 7.19 39.036 0 24.525 0 11.264 0 .843 9.565.843 24.934.844 40.369 10.342 50 26.042 50c12.533 0 21.306-7.388 22.69-19.657H33.76c-.593 4.552-2.968 8.048-7.981 8.048-7.916 0-9.367-6.267-9.367-12.93 0-9.168 3.298-13.851 8.773-13.851 4.881 0 7.982 2.836 8.443 7.783h14.776Z",
    fill: "#A9BACD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.844)",
    d: "M0 0h47.889v50H0z"
  })))));
};
export default SvgC;